import React from "react";
import { Button } from "@material-ui/core";
import shortfetch from "../../../components/data/fetch.jsx";

const TransferModelData = (props) => {
  const { history, Change_State, ModelID } = props;

  const transfer_model_data = async () => {
    let post_json = {
      type: "Transfer_Model_Data",
      currentID: ModelID,
      auth: localStorage.getItem("auth"),
    };

    let data = await shortfetch(post_json);

    if (data.geslaagd) {
      let newID = Number(data.max);
      history.push("/Form/Modellen/" + newID);
      Change_State(newID);
    } else {
      alert("Er is iets fout gegaan tijdens het opslaan.");
    }
  };

  return (
    <Button
      onClick={() => transfer_model_data()}
      style={{ background: "#D3D3D1", width: "40%" }}
    >
      Model {ModelID} Omzetten
    </Button>
  );
};

export default TransferModelData;
